<div class="component-single-forum-small-view" routerLinkActive="component-single-forum-small-view--active">
  <a [routerLink]="['/blog', blogPostData.post_id]">
    <div class="component-single-forum-small-view__single">
      <h5 [innerHTML]="blogPostData.post_category | texthighlight: searchQuery">Bussiness</h5>
      <h3 [innerHTML]="blogPostData.post_name | texthighlight: searchQuery"></h3>
      <h4 class="hide-element-result-as-list" [innerHTML]="blogPostData.post_content | texthighlight: searchQuery"></h4>
    </div>
    <!--<div class="component-single-forum-small-view__single component-single-forum-small-view__single&#45;&#45;image">-->
    <!--<img src="../../assets/images/demo-image.jpg" alt="">-->
    <!--</div>-->
  </a>
</div>
